<template>
  <div class="card">
    <div class="card-header d-flex justify-content-between align-items-center">
      <span class="fw-bold">
        {{ metricas.top_produtos.titulo }}
      </span>
      <small class="text-muted" v-if="products && products.length">
        {{ products.length }} itens
      </small>
    </div>
    <div class="card-body p-0">
      <div class="table-responsive" style="height: 500px">
        <table class="table table-hover mb-0 align-middle">
          <thead class="table-light">
          <tr>
            <th style="width: 52px;"></th>
            <th>Produto</th>
            <th class="text-end">Qtd</th>
            <th class="text-end">Total</th>
            <th class="text-end" title="Representatividade em relação ao total vendido no período">%</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in products" :key="item.produto_id">
            <td>
              <img
                  :src="getImageUrl(item)"
                  class="img-thumbnail"
                  style="width: 42px; height: 42px; object-fit: cover;"
                  :alt="item.descricao || 'Produto'"
              />
            </td>
            <td>
              <div class="fw-semibold">{{ item.descricao || ('ID ' + item.produto_id) }}</div>
              <div class="small text-muted">
                Pedidos: {{ item.qtd_pedidos || 0 }}
              </div>
              <div class="small">
                <span class="badge bg-secondary me-1">B2B: {{ item.qtd_pedidos_b2b || 0 }}</span>
                &nbsp;
                <span class="badge bg-secondary me-1">CC: {{ item.qtd_pedidos_callcenter || 0 }}</span>
                &nbsp;
                <span class="badge bg-secondary">FV: {{ item.qtd_pedidos_forca_vendas || 0 }}</span>
              </div>
            </td>
            <td class="text-end">
              {{ formatNumber(item.quantidade_vendida_total) }}
              <div class="small">
                <span class="badge bg-secondary me-1">B2B: {{ formatNumber(item.quantidade_vendida_b2b) }}</span>
                <br />
                <span class="badge bg-secondary me-1">CC: {{ formatNumber(item.quantidade_vendida_callcenter) }}</span>
                <br />
                <span class="badge bg-secondary">FV: {{ formatNumber(item.quantidade_vendida_forca_vendas) }}</span>
              </div>
            </td>
            <td class="text-end">
              {{ formatMoney(item.total_vendido) }}
              <div class="small text-muted">
                <span class="badge bg-secondary me-1">B2B: {{ formatMoney(item.total_vendido_b2b) }}</span>
                <br>
                <span class="badge bg-secondary me-1">CC: {{ formatMoney(item.total_vendido_callcenter) }}</span>
                <br>
                <span class="badge bg-secondary me-1">FV: {{ formatMoney(item.total_vendido_forca_vendas) }}</span>
              </div>
            </td>
            <td class="text-end" title="Representatividade em relação ao total vendido no período">
              {{ formatPercent(item.representatividade_percentual) }}
            </td>
          </tr>
          <tr v-if="!products || !products.length">
            <td colspan="5" class="text-center py-4 text-muted">
              Nenhum produto encontrado no período.
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import {cdnUrlProduto} from "@/helpers/url";

export default {
  name: "TopProdutos",
  props: [
     "metricas"
  ],
  computed: {
    products () {
      return this.metricas.top_produtos.metricas;
    }
  },
  methods: {
    getImageUrl(item) {
      const id = item.imagem_id || item.produto_id;
      return cdnUrlProduto(id);
    },
    formatMoney(value) {
      const num = Number(value) || 0;
      return num.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL"
      });
    },
    formatShort(value) {
      const num = Number(value) || 0;
      // mostra rápido, sem cifrão (usa na linha de baixo)
      return num.toLocaleString("pt-BR", { maximumFractionDigits: 0 });
    },
    formatNumber(value) {
      const num = Number(value) || 0;
      return num.toLocaleString("pt-BR");
    },
    formatPercent(value) {
      const num = Number(value) || 0;
      return num.toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) + "%";
    }
  }
};
</script>

<style scoped>
.table td,
.table th {
  vertical-align: middle;
}
.badge {
  font-weight: 500;
}
</style>
